import { EventEmitter, Injectable, Input, Output } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export const MaxLengthMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class Max extends Clazz {
    @Input()
    maxLength!: number;

    @Output()
    public maxLengthChange = new EventEmitter<boolean>();
  }

  return Max;
};

export const MaxLengthMixinInputs = ["maxLength"];
